import { render, staticRenderFns } from "./internationalSite.vue?vue&type=template&id=21c99993"
import script from "./internationalSite.vue?vue&type=script&lang=js"
export * from "./internationalSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports